import {useI18n} from 'i18n/I18nContext'
import CompanyUpdate from 'organization/OrganizationSettings/CompanyUpdate'
import React from 'react'

export default function CompanySettings() {
  const {t} = useI18n()
  return (
    <div className="col-12">
      <div className="create__event-area">
        <div className="body__card-wrapper attendant__wrapper">
          <div className="card__header-top">
            <div className="card__title-inner">
              <h4 className="event__information-title">
                {t('orgSettings.companyDataTitle')}
              </h4>
            </div>
          </div>
          <div className="setting__main-wrapper pt-25 pb-100">
            <CompanyUpdate />
          </div>
        </div>
      </div>
    </div>
  )
}
